import addr2 from "../../../../assets/images/contact/address_2.png";
import addr3 from "../../../../assets/images/contact/address_3.png";
import amtaWarehouse from "../../../../assets/images/contact/AMTA_WAREHOUSE.jpg";
import coimbatoreWarehouse from "../../../../assets/images/contact/Coimbatore_warehouse.jpeg";
import howrahChamrailWarehouse from "../../../../assets/images/contact/HOWRAH_CHAMRAIL_WAREHOUSE.jpeg";
import jharkhandWarehouse from "../../../../assets/images/contact/Jharkhand_Warehouse.png";
import kolhapurWarehouse from "../../../../assets/images/contact/Kolhapur_Warehouse.jpeg";
import ludhianaWarehouse from "../../../../assets/images/contact/Ludhiana_warehouse.jpeg";
import rajkotWarehouse from "../../../../assets/images/contact/Rajkot_Warehouse.jpeg";

const LANDING_PREFIX = "https://images.nowpurchase.com/landing/";

// Hosted rather than bundled, so they can be swapped without a deploy.
export const addressImages = {
  corporate: `${LANDING_PREFIX}20260424030936_address_1.jpg`,
  puneOffice: `${LANDING_PREFIX}20260424031331_address_4.png`,
  puneScrapUnit: `${LANDING_PREFIX}20260424072206_Pune PU (1).png`,
  amta: amtaWarehouse,
  kolhapur: kolhapurWarehouse,
  chamrail: howrahChamrailWarehouse,
  jharkhand: jharkhandWarehouse,
  ludhiana: ludhianaWarehouse,
  coimbatore: coimbatoreWarehouse,
  // Not currently placed on the page, kept so the assets stay referenced.
  spare: [addr2, addr3, rajkotWarehouse],
};

// Address copy matches the reformatted list in the July'26 update doc.
export const ADDRESSES = [
  {
    name: "Corporate Office",
    address:
      "Kariwala Tower, EP Block, Sector V, Bidhannagar, Kolkata, West Bengal 700091",
    image: addressImages.corporate,
    mapUrl: "https://goo.gl/maps/p2p8RqPuFrzdLQC8A",
    id: "OurAddresses_CorporateOffice_ViewOnMap",
  },
  {
    name: "Pune Office",
    address:
      "Suratwala Mark Plazzo, 7th Floor Office Number-702, Wakad Road, Hinjewadi Survey Number - 28B/1, Hinjavadi, Mulshi, Pune, Maharashtra - 411057",
    image: addressImages.puneOffice,
    mapUrl: "https://maps.app.goo.gl/EUgW1XDLxEvDmdXo6",
    id: "OurAddresses_PuneOffice_ViewOnMap",
  },
  {
    name: "Amta Scrap Recycling Unit",
    address:
      "Pashupati Industrial Complex, Uluberia - Amta Rd, Serpur, Uluberia, West Bengal - 711401",
    image: addressImages.amta,
    mapUrl: "https://maps.app.goo.gl/Sv4mndkq3qMngMVBA",
    id: "OurAddresses_AmtaScrapRecyclingUnit_ViewOnMap",
  },
  {
    name: "Pune Scrap Recycling Unit",
    address:
      "Plot No. D-69, Chakan Industrial Area, Phase-II, Bhamboli Road, Tehsil-Khed - Pune, Maharashtra - 410501",
    image: addressImages.puneScrapUnit,
    mapUrl: "https://maps.app.goo.gl/xRhebzAw6F2cmx3V9",
    id: "OurAddresses_PuneScrapRecyclingUnit_ViewOnMap",
  },
  {
    name: "Kolhapur Warehouse",
    address:
      "Plot no.12, Beside Jafrani weight bridge, M.I.D.C Shiroli - Kolhapur, Maharashtra – 416122",
    image: addressImages.kolhapur,
    mapUrl: "https://goo.gl/maps/ajyADxVXhyFqV6XN9",
    id: "OurAddresses_KolhapurWarehouse_ViewOnMap",
  },
  {
    name: "Chamrail Warehouse",
    address:
      "Shriram Warehousing, Mouza - Chamrail, NH-6, Bombay Road, P.S. Liluah - Dist. Howrah, West Bengal - 711114",
    image: addressImages.chamrail,
    mapUrl: "https://goo.gl/maps/CLY5radcRTTrVShc9",
    id: "OurAddresses_ChamrailWarehouse_ViewOnMap",
  },
  {
    // Not in the July'26 doc list, so its copy is left as it was.
    name: "Jharkhand Warehouse",
    address:
      "Plot No. 566, Khata No. 10, Mouza Kanderbera, Thana No. 327, Halka No. 2, P.S. Chandil, Chandil, District Seraikela Kharsawan, Jharkhand - 832401",
    image: addressImages.jharkhand,
    mapUrl: "https://maps.google.com/?q=22.8843722,86.1466028",
    id: "OurAddresses_JharkhandWarehouse_ViewOnMap",
  },
  {
    name: "Ludhiana Warehouse",
    address:
      "Godown No. 31, Deepak Godown, Malerkotla Road, Village - Kaind, Ludhiana, Punjab - 141116",
    image: addressImages.ludhiana,
    mapUrl: "https://maps.google.com/?q=30.7844119,75.8558694",
    id: "OurAddresses_LudhianaWarehouse_ViewOnMap",
  },
  {
    name: "Coimbatore Warehouse",
    address:
      "Door 4/63/3, Kollupalayam Road Sulur - Kaniyur, Coimbatore, Tamil Nadu - 641659",
    image: addressImages.coimbatore,
    mapUrl: "https://www.google.com/maps?q=11.0997612,77.1425165",
    id: "OurAddresses_CoimbatoreWarehouse_ViewOnMap",
  },
];
